import { Component, ErrorInfo, ReactNode } from 'react';
import FehlerModal from './FehlerModal';

function recordError(payload: Record<string, unknown>) {
  try {
    const existing = JSON.parse(localStorage.getItem('debug-errors') || '[]');
    existing.push({ ...payload, ts: new Date().toISOString(), href: location.href });
    localStorage.setItem('debug-errors', JSON.stringify(existing.slice(-20)));
  } catch {}
}

interface State {
  error: Error | null;
  componentStack: string | null;
}

export class RouteErrorBoundary extends Component<{ children: ReactNode; label: string }, State> {
  state: State = { error: null, componentStack: null };

  static getDerivedStateFromError(error: Error): State {
    return { error, componentStack: null };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    const domSnippet = (() => {
      try {
        return document.body.outerHTML.substring(0, 8000);
      } catch {
        return null;
      }
    })();
    recordError({
      kind: 'route.error-boundary',
      label: this.props.label,
      message: error.message,
      stack: error.stack,
      componentStack: info.componentStack,
      domSnippet,
    });
    this.setState({ componentStack: info.componentStack || null });
  }

  render() {
    if (this.state.error) {
      return (
        <FehlerModal
          fehler={this.state.error}
          componentStack={this.state.componentStack}
          quelle={`route:${this.props.label}`}
        />
      );
    }
    return this.props.children;
  }
}
